import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/core/components/ui/card";
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis } from "recharts";
import { ChartContainer, ChartTooltip } from "@/core/components/ui/chart";
import { configs } from "../consts/configs";
import { useTranslation } from "react-i18next";
import { formatMonth } from "@/core/utils";
import { ReportViewerReservationsEvolutionProps } from "../types";

export function ReportViewerReservationsEvolution({
  data,
  highest,
  lowest,
}: ReportViewerReservationsEvolutionProps) {
  const [translate] = useTranslation(["insights"]);

  const highestMonth = highest ? formatMonth(highest.month) : null;
  const lowestMonth = lowest ? formatMonth(lowest.month) : null;

  return (
    <Card className="border-secondary">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <span className="text-blue-600">📊</span>
          {translate("report-viewer-reservations-evolution-title")}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-64 mb-6">
          <ResponsiveContainer>
            <ChartContainer config={configs} className="min-h-[200px] w-full">
              <LineChart data={data}>
                <XAxis dataKey="month" />
                <YAxis />
                <ChartTooltip />
                <Line
                  type="monotone"
                  dataKey="reservations"
                  stroke="#2563eb"
                  strokeWidth={2}
                />
              </LineChart>
            </ChartContainer>
          </ResponsiveContainer>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <KpiCard
            label={translate(
              "report-viewer-reservations-evolution-highest-peak",
            )}
            value={
              highest && highestMonth
                ? `${highestMonth.m}/${highestMonth.y} (${highest.reservations} reservas)`
                : "—"
            }
            className="bg-green-50 text-green-600"
          />
          <KpiCard
            label="Vale do período"
            value={
              lowest && lowestMonth
                ? `${lowestMonth.m}/${lowestMonth.y} (${lowest.reservations} reservas)`
                : "—"
            }
            className="bg-orange-50 text-orange-600"
          />
        </div>
      </CardContent>
    </Card>
  );
}

function KpiCard({
  label,
  value,
  className,
}: {
  label: string;
  value: string;
  className?: string;
}) {
  return (
    <div className={`p-4 rounded-lg ${className}`}>
      <p className="text-sm text-gray-600">{label}</p>
      <p className="font-bold">{value}</p>
    </div>
  );
}
